<div class="login">

  <mat-card>
    <mat-card-header>
      <mat-card-title style="margin-bottom: 2rem">Create or Reset Your Password</mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <form [formGroup]="form" #loginForm class="form" >
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="text" formControlName="email" (keyup.enter)="login()" autocomplete="on"/>
            @if (form.get('email')?.hasError('required')) {
              <mat-error>Email is required field</mat-error>
            }
          </mat-form-field>
        </div>
        
 
      </form>

    </mat-card-content>

    <mat-card-actions style="display: flex; justify-content: space-between; padding-bottom: 1rem">
        <lib-button       
        style="padding: 1rem 0" >
          <a href="/login" >Back</a>
        </lib-button>
        <lib-button [disabled]="form.invalid || loading" (click)="login()">Send Password Reset Link</lib-button>

    </mat-card-actions>

    <p class="help-link">Need help? 
      <a class="help" href="mailto:info@owlhub.com">  info&#64;owlhub.com</a>
    </p>

    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>

</div>